export const HUB_ATTENDEES_COLUMNS_STORAGE_KEY = 'HubAttendeeListView';

const HUB_ATTENDEES_DESELECTED_CUSTOM_FIELDS_STORAGE_KEY_PREFIX = 'HubAttendeeListView.deselectedCustomFields.';

export type THubAttendeeFixedColumnId =
    | 'name'
    | 'email'
    | 'organization'
    | 'organizationType'
    | 'title'
    | 'phoneNumber'
    | 'salutation'
    | 'assistantEmail'
    | 'accessCode'
    | 'externalAttendeeId'
    | 'registrationDate'
    | 'registrationStatus';

export type THubAttendeeCustomFieldColumnId = `${number}`;

export type THubAttendeeColumnId = THubAttendeeFixedColumnId | THubAttendeeCustomFieldColumnId;

export interface IHubCustomFieldColumn {
    customFieldId: number;
    label: string;
}

export const MANDATORY_HUB_ATTENDEE_COLUMN_ID: THubAttendeeFixedColumnId = 'name';

// Canonical chooser order of the fixed columns.
export const FIXED_HUB_ATTENDEE_COLUMN_IDS: THubAttendeeFixedColumnId[] = [
    'name',
    'email',
    'organization',
    'organizationType',
    'title',
    'phoneNumber',
    'salutation',
    'assistantEmail',
    'accessCode',
    'externalAttendeeId',
    'registrationDate',
    'registrationStatus',
];

export const DEFAULT_HUB_ATTENDEE_COLUMNS: THubAttendeeFixedColumnId[] = [
    'name',
    'email',
    'organization',
    'title',
    'registrationStatus',
    'registrationDate',
];

export const getDeselectedCustomFieldsStorageKey = (eventHubId: number): string =>
    `${HUB_ATTENDEES_DESELECTED_CUSTOM_FIELDS_STORAGE_KEY_PREFIX}${eventHubId}`;

// Custom field columns use the custom field id as the column id, like the event attendees list.
export const toCustomFieldColumnId = (customFieldId: number): THubAttendeeCustomFieldColumnId => `${customFieldId}`;

export const parseCustomFieldIds = (columnIds: string[]): number[] =>
    columnIds.filter(columnId => /^\d+$/.test(columnId)).map(Number);

export const parseColumnIds = (columns: string): string[] =>
    columns
        .split(',')
        .map(column => column.trim())
        .filter(column => column !== '');

// Keeps only known fixed columns, always starts with the mandatory one and follows the canonical order.
export const normalizeFixedColumns = (columnIds: string[]): THubAttendeeFixedColumnId[] => {
    const selected = new Set(columnIds);
    return [
        MANDATORY_HUB_ATTENDEE_COLUMN_ID,
        ...FIXED_HUB_ATTENDEE_COLUMN_IDS.filter(id => id !== MANDATORY_HUB_ATTENDEE_COLUMN_ID && selected.has(id)),
    ];
};

export const parseDeselectedCustomFieldIds = (stored: string | null): number[] =>
    parseCustomFieldIds(parseColumnIds(stored ?? ''));
